module.exports = __webpack_public_path__ + "img/TotalEnergies_120X35.c007a416.png";